import { Tooltip, Typography } from '@mui/material'
import { AssignedWorkAreaDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { useMemo } from 'react'
import { getYardAssignmentText } from '../../tableConfigs/operationalEquipmentTableHelper'

interface Props {
  assignments: AssignedWorkAreaDto[]
}

export const OperationalEquipmentYardAssignment = ({ assignments }: Props) => {
  const { t } = useTranslate()

  const computedText = useMemo(() => {
    return getYardAssignmentText(assignments)
  }, [assignments])

  if (assignments.length === 0)
    return <Typography variant='body2'>{t('notAssigned', 'Not assigned')}</Typography>

  return (
    <Tooltip title={computedText}>
      <Typography variant='body2' noWrap maxWidth={180}>
        {computedText}
      </Typography>
    </Tooltip>
  )
}
